module.exports = __webpack_public_path__ + "static/img/bg.33f91fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = yEeP
// module chunks = 9